import { debounce, scrollToX } from "utils";

export const initSlider = async () => {
  document.querySelectorAll<HTMLElement>("[data-slider]").forEach((slider) => {
    const rotateDuration = +slider.dataset.sliderSlideDuration;
    const container = slider.querySelector<HTMLElement>("[data-slider-container]");
    const buttons = slider.querySelectorAll<HTMLButtonElement>("[data-slider-button]");
    const prev = slider.parentElement.querySelector<HTMLButtonElement>("[data-slider-prev]");
    const next = slider.parentElement.querySelector<HTMLButtonElement>("[data-slider-next]");

    const rotateRef = { current: null };
    const manualScroll = { current: null };

    const resizeHeight = () => {
      const autoRotate = slider.dataset.sliderAutoRotate === "true";
      const slides = container?.scrollWidth / container?.clientWidth;
      if (window.innerWidth >= 1024) {
        container.style.maxHeight = "";
        return;
      }
      if (Math.floor(slides) <= 1) {
        return;
      }
      const currentIndex = Math.floor(container.scrollLeft / container.offsetWidth);

      const currentSlide = [
        ...container.querySelectorAll("[class*=snap-start],[class*=snap-center]"),
      ][currentIndex];

      if (currentSlide?.scrollHeight) {
        container.style.maxHeight = `${currentSlide.scrollHeight + 15}px`;
      } else {
        container.style.maxHeight = "";
      }
    };
    resizeHeight();
    const debounceResizeHeight = debounce(resizeHeight, 120);

    const handleResize = () => {
      const autoRotate = slider.dataset.sliderAutoRotate === "true";
      const slides = container?.scrollWidth / container?.clientWidth;
      clearInterval(rotateRef.current);
      debounceResizeHeight();

      if (slides > 1 && autoRotate) {
        const currentIndex = Math.round(container.scrollLeft / container.clientWidth);
        buttons.forEach((button) => {
          button.classList.remove("active");
        });
        setTimeout(() => {
          buttons[currentIndex].classList.add("active");
        }, 2);

        rotateRef.current = setInterval(() => {
          const nextPosition = container.scrollLeft + container.clientWidth;

          buttons.forEach((button) => {
            button.classList?.remove("active");
          });

          container?.classList?.remove("snap-mandatory", "snap-x");
          scrollToX(
            250,
            nextPosition - 50 >= container.scrollWidth - container.clientWidth ? 0 : nextPosition,
            container,
            () => {
              const nextIndex = Math.round(container.scrollLeft / container.clientWidth);
              buttons[nextIndex]?.classList?.add("active");
              container?.classList?.add("snap-mandatory", "snap-x");
            }
          );
        }, rotateDuration * 1000);
      }

      if (prev && next) {
        prev.style.display = container.scrollLeft ? "" : "none";
        next.style.display =
          container.scrollLeft + container.clientWidth < container.scrollWidth - 10 ? "" : "none";
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        manualScroll.current = true;
        const buttonIndex = +button.dataset?.sliderButton;
        const targetPosition = buttonIndex * container.clientWidth;

        if (targetPosition === container.scrollLeft) return;

        container.classList.remove("snap-mandatory", "snap-x");
        scrollToX(250, targetPosition, container, () => {
          container.classList.add("snap-mandatory", "snap-x");
          button.classList.add("active");
          manualScroll.current = false;
          resizeHeight();
          handleResize();
        });
      });
    });

    if (prev) {
      prev.addEventListener("click", () => {
        manualScroll.current = true;
        const buttonIndex = Math.round(container.scrollLeft / container.clientWidth) - 1;
        const targetPosition = buttonIndex * container.clientWidth;

        if (targetPosition === container.scrollLeft) return;

        container.classList.remove("snap-mandatory", "snap-x");
        scrollToX(250, targetPosition, container, () => {
          container.classList.add("snap-mandatory", "snap-x");
          manualScroll.current = false;
          resizeHeight();
          handleResize();
        });
      });
    }

    if (next) {
      next.addEventListener("click", (e) => {
        manualScroll.current = true;
        const buttonIndex = Math.round(container.scrollLeft / container.clientWidth) + 1;
        const targetPosition = buttonIndex * container.clientWidth;

        if (targetPosition === container.scrollLeft) return;

        container.classList.remove("snap-mandatory", "snap-x");
        scrollToX(250, targetPosition, container, () => {
          container.classList.add("snap-mandatory", "snap-x");
          manualScroll.current = false;
          resizeHeight();
          handleResize();
        });
      });
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    container.addEventListener("scroll", () => {
      if (manualScroll.current) return null;
      debounceResizeHeight();
    });
    document.addEventListener("scroll-slider-update", handleResize);
  });
};
